import Journal from "@/src/_types/journal";
import JournalMenu from "@/src/_types/JournalMenu";
import MenuItem from "@/src/_types/menu-item";

export const mapToMenuItems = (menu: JournalMenu[], journal: Journal): MenuItem[] => {
    return menu?.map((item: any) => ({
        icon: item.iconfa || undefined,
        label: item.title,
        link: (item.type === 'link' || journal.is_main_site === true)
            ? item.url
            : `/${journal.journal_url}${item.url}`,
        children: item.children ? mapToMenuItems(item.children, journal) : undefined
    })) || [];
};
